import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { Slider, Pagination } from 'react-slick';
import { ImageDetails } from '../../';
import { formatNumber } from '../../../utils';
import './styles.scss';

const propTypes = {
  livecams: PropTypes.array,
  username: PropTypes.string,
  belongsToCurrentUser: PropTypes.bool,
};

const contextTypes = {
  router: PropTypes.object,
};

const defaultProps = {
  livecams: [],
  username: '',
  belongsToCurrentUser: false,
  slickSettings: {
    infinite: true,
    arrows: false,
    adaptiveHeight: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    paginationName: 'favorite-livecams-pagination',
    afterChange: () => {
      window.dispatchEvent(new CustomEvent('checkImageLazyload'));
    },
    init: () => {
      window.dispatchEvent(new CustomEvent('checkImageLazyload'));
    },
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    }, {
      breakpoint: 500,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    }],
  },
};


class FavoriteLivecams extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      navigationEnabled: false,
    };
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.livecams.length > 3) {
      this.setState({ navigationEnabled: true });
    } else {
      this.setState({ navigationEnabled: false });
    }
  }

  componentDidMount() {
    if (this.props.livecams.length > 3) {
      this.setState({ navigationEnabled: true });
    } else {
      this.setState({ navigationEnabled: false });
    }
  }

  next() {
    if (this.state.navigationEnabled) { this.favoriteSlider.slickNext(); }
    document.dispatchEvent(new CustomEvent('resize'));
  }

  previous() {
    if (this.state.navigationEnabled) { this.favoriteSlider.slickPrev(); }
    document.dispatchEvent(new CustomEvent('resize'));
  }

  paginationRender(currentPage, totalPages) {
    return (
      <span type="text" className="pagination-numbers">{currentPage} / {totalPages} </span>
    );
  }

  render() {
    const { livecams, slickSettings, username, belongsToCurrentUser } = this.props;
    const { navigationEnabled } = this.state;
    const disabled = (navigationEnabled) ? '' : ' disabled';
    const loaderProps = { style: { height: 194 }, dark: true };

    return (
      <div className="member-slider-group">
        <div className="row">
          <div className="section-header col-12 bg-fff-80 border-grey">
            <div className="row no-gutters">
              <Link
                to={`/livecams/members/${encodeURIComponent(username)}`}
                className="title-link border-r-grey title-block"
              >Favorite Livecams</Link>
              <div className="title-block col">{formatNumber(livecams.length)} Cameras</div>
              <div className="title-block col text-right favorite-livecams-pagination">
                <Pagination name="favorite-livecams-pagination" />
              </div>
              <div
                className={`title-block border-l-grey pagination-button${disabled}`}
                onClick={this.previous}
              ><i className="icon-ButtonArrowLeft" /></div>
              <div
                className={`title-block border-l-grey pagination-button${disabled}`}
                onClick={this.next}
              ><i className="icon-ButtonArrowRight" /></div>
            </div>
          </div>
        </div>
        {livecams.length > 0 &&
        <div className="row">
          <Slider
            {...slickSettings}
            ref={c => this.favoriteSlider = c}
            className="favorite-livecams-slider"
            paginationRender={this.paginationRender}
          >
            {livecams.map(function (livecam, index) {
              const currentViewers = (livecam.current_viewers === 0 || !livecam.current_viewers) ? ' no-viewers ' : '';
              const snapshotText = livecam.title;
              // const is_active = (livecam.live) ? ' is-online ' : 'is-offline profile';
              let statusClass = '';
              if (livecam.is_meditation) {
                statusClass = ' is-meditation ';
              } else {
                statusClass = (livecam.live) ? ' is-online ' : 'is-offline profile';
              }

              return (
                <div
                  className={`favorite-cam-item-wrap cam-container ${statusClass}`}
                  key={livecam.id}
                >
                  <ImageDetails
                    className="cam-item"
                    isActive={livecam.live}
                    imgSrc={livecam.thumbnail_large_url.replace('http://', 'https://')}
                    to={`/livecams/members/${encodeURIComponent(username)}/${livecam.slug}`}
                    camId={livecam.id}
                    slideNumber={index}
                    fallbackImgSrc={livecam.thumbnail_large_url.replace('http://', 'https://')}
                    imgHeight={195}
                  >
                    <div
                      className={'not-watching'}
                      data-default-title={livecam.title}
                    >
                      <span
                        className={'text-capitalize u-font-foundation-roman u-textSize-18'}
                      >{snapshotText}</span>
                      {livecam.current_viewers > 0 && <div className="cam-item-separator" />}
                    </div>
                    {livecam.current_viewers > 0 &&
                    <div>
                      <div className="text-uppercase u-font-foundation-light u-textSize-16">
                        {livecam.current_viewers} viewers
                      </div>
                    </div>
                    }
                  </ImageDetails>
                </div>
              );
            })}
          </Slider>
        </div>
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    livecams: _.get(state.memberProfile.data, 'favorites.livecams', []),
    dataToggle: state.memberProfile.dataToggle,
  };
};

FavoriteLivecams.propTypes = propTypes;
FavoriteLivecams.contextTypes = contextTypes;
FavoriteLivecams.defaultProps = defaultProps;

export default connect(mapStateToProps)(FavoriteLivecams);
